export default __webpack_public_path__ + "static/df73cf9c8b5908710c2822a3a3a8c79d.png";